import type { PublicConfig } from './types';
import consultQrImage from './assets/consult-qr.png';

export const VIEW_VALUES = ['evaluate', 'reports'] as const;
export type View = (typeof VIEW_VALUES)[number];
export const DEFAULT_VIEW: View = 'evaluate';
export const DEFAULT_CONFIG: PublicConfig = {
  consult_title: '需要进一步解读这份报告？',
  consult_content:
    '如果你希望更准确地判断文章问题、制定 GEO 优化路径，或系统提升品牌在 AI 搜索中的可见度与引用机会，欢迎联系我们。我们可以结合你的行业、内容资产和业务目标，提供专业报告解读、GEO 诊断与落地优化服务。',
  consult_qr_url: consultQrImage,
  article_max_chars: 30000,
  keywords_max_chars: 500,
  initial_poll_after_ms: 2000,
  evaluation_units_per_day: 10,
  single_mode_units: 1,
  compare_mode_units: 2,
  report_retention_days: 90
};
export const POLL_AFTER_MS = 2000;
export const HIDDEN_POLL_AFTER_MS = 7000;
export const MAX_TASK_NAME = 200;
export const EVENT_ALLOWLIST = new Set([
  'page_view',
  'start_evaluation_click',
  'mode_switch',
  'sms_send_click',
  'sms_send_success',
  'login_success',
  'report_create_click',
  'report_create_success',
  'report_completed',
  'report_failed',
  'report_history_click',
  'consult_qr_expose'
]);
export const ERROR_MESSAGES: Record<string, string> = {
  ArticleEvaluationUnauthorized: '登录状态已过期，请重新登录',
  SMSRateLimited: '验证码发送过于频繁，请稍后再试',
  CaptchaRequired: '请完成安全验证后再试',
  VerificationCodeInvalid: '验证码错误或已过期',
  EvaluationQuotaExceeded: '今日评测额度已用完，请明天再试',
  EvaluationContentRejected: '文章内容不符合提交规则',
  EvaluationServiceBusy: '评测服务繁忙，请稍后再试',
  EvaluationWorkflowFailed: '评测失败，请重试该文章'
};
